import { gql, useQuery } from "@apollo/client";
import React, { useEffect } from "react";

import type { IShopQuery } from "@repo/shopify/queries/others-gql";
import { shopQuery } from "@repo/shopify/queries/others-gql";

import ParseContent from "@molecules/ParseContent";

import { NOTIFICATIONS } from "@const/notifications";

import { useLayoutStore } from "@store/layout";

export default function TermsAndConditions() {
  const { openToast } = useLayoutStore();

  const { data } = useQuery<IShopQuery>(gql(shopQuery.query), {
    onError: (error) => {
      openToast(NOTIFICATIONS.ERROR_SERVER);
      throw new Error(error.message);
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pc:gap-10 col-span-8 flex h-fit flex-col gap-5 wrap-break-word">
      <h2 className="text-title pc:flex hidden">Terms and Conditions</h2>
      <ParseContent html={data?.shop.termsOfService?.body || ""} />
    </section>
  );
}
